const initialState = {
  adminsInfo: [],
  netError: null
};

export default (state = initialState, action) => {
  let currentState = state;
  switch (action.type) {
    case "FETCH_ADMINS_DATA_SUCCESS":
      currentState = { ...state, adminsInfo: action.payload, netError: null };
      break;

    case "FETCH_ADMINS_DATA_FAILURE":
      currentState = { ...state, netError: action.error };
      break;

    default:
  }
  return currentState;
};
